export enum QuoteProductType {
  COURSE = 'COU',
  ACCOMMODATION = 'ACC',
  OPTION = 'OPT',
}
